export const blockIconsSocialGavelNew = (
	<span className='material-symbols-outlined'>gavel</span>
);
